<template>
    <div>
        <Head :title="`${form.name}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/affiliates">Affiliates</Link>
                <span class="text-indigo-400 font-medium">/</span>
                {{ form.name }}
            </h1>
        </div>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
                    <select-input v-model="form.callback_type" :error="form.errors.callback_type"  class="pb-8 pr-6 w-full lg:w-1/2" label="Callback type">
                        <option value="get">GET</option>
                        <option value="post">POST</option>
                    </select-input>
                    <text-input v-model="form.affiliate_id" :error="form.errors.affiliate_id" class="pb-8 pr-6 w-full" label="Affiliate id" />
                    <textarea-input v-model="form.redirectLink" :error="form.errors.redirectLink" class="pb-8 pr-6 w-full" label="Redirect Link" />
                    <textarea-input v-model="form.callbackLink" :error="form.errors.callbackLink" class="pb-8 pr-6 w-full" label="Callback Link" />
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Update Affiliate
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import throttle from 'lodash/throttle'
import TextareaInput from "@/Shared/TextareaInput.vue";

export default {
    components: {
        TextareaInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    props: {
        affiliate: Object
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.affiliate.name,
                affiliate_id: this.affiliate.affiliate_id,
                callback_type: this.affiliate.callback_type,
                redirectLink: this.affiliate.redirectLink,
                callbackLink: this.affiliate.callbackLink,
            }),
            responses: []
        }
    },
    methods: {
        update() {
            this.form.post(`/affiliates/${this.affiliate.id}`)
        }
    },
}
</script>
